import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("link", {
  rel: "stylesheet",
  href: "https://www.w3schools.com/w3css/4/w3.css"
}, null, -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "sidebar" }
const _hoisted_4 = {
  key: 0,
  alt: "",
  src: "/full-logo-white.png",
  class: "-lg:hidden w-48 hover:opacity-80 transition-opacity duration-200"
}
const _hoisted_5 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_router_view, { onAuthenticate: _ctx.handleAccess }, {
      default: _withCtx(({Component, route}) => [
        (route.path != '/')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Sidebar, {
                  items: this.$store.state.sidebarMenu,
                  activeMenu: this.$store.state.sidebarActive,
                  event: "update:activeSidebar",
                  isSidebarCollapsed: this.$store.state.isSidebarCollapsed,
                  collapseEvent: "update:collapseSidebar",
                  "onUpdate:activeSidebar": _ctx.updateSidebar,
                  "onUpdate:collapseSidebar": _ctx.updateCollapseSidebar
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "cursor-pointer",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (this.haveApprovalAccess() ? _ctx.$router.push('/aprovacoes') : _ctx.$router.push('/painel') ))
                    }, [
                      (!this.$store.state.isSidebarCollapsed)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                        : _createCommentVNode("", true),
                      _createElementVNode("img", {
                        alt: "",
                        src: "/logo-white.png",
                        class: _normalizeClass(["w-16 hover:opacity-80 transition-opacity duration-200", this.$store.state.isSidebarCollapsed ? '' : 'hidden -lg:block'])
                      }, null, 2)
                    ])
                  ]),
                  _: 1
                }, 8, ["items", "activeMenu", "isSidebarCollapsed", "onUpdate:activeSidebar", "onUpdate:collapseSidebar"])
              ]),
              _createVNode(_component_Header, {
                userData: {
          'Nome': this.$store.state.user.name,
          'Email': this.$store.state.user.email,
          'CNPJ': this.$store.state.user.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
        },
                avatar: this.$store.state.user.avatarImage,
                logOutFunction: _ctx.logout,
                haveSidebar: true,
                isSidebarCollapsed: this.$store.state.isSidebarCollapsed,
                displayName: this.$store.state.user.name
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(this.$store.state.user.nomeFantasia), 1),
                    _createElementVNode("div", null, _toDisplayString(this.$store.state.user.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["userData", "avatar", "logOutFunction", "isSidebarCollapsed", "displayName"])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          class: _normalizeClass(["transition-all ease-out-in duration-500", route.path != '/' ? this.$store.state.isSidebarCollapsed ? 'ml-24 -md:ml-0' : 'ml-64 -lg:ml-24 -md:ml-0' : '' ])
        }, null, 8, ["class"]))
      ]),
      _: 1
    }, 8, ["onAuthenticate"])
  ], 64))
}